import { DropdownInput } from "@joonapp/web-shared"
import { useEffect, useMemo } from "react"

import useCoachSelectStore from "./hooks/useCoachSelectStore"
import useUserRole from "../../hooks/useUserRole"
import { useCoachDirectReportsQuery } from "../../networking/coachingGroups/queries"
import { useUserQuery } from "../../networking/user/queries"

const CoachDropdown = () => {
  const { selectedCoachUserId, setSelectedCoachUserId } = useCoachSelectStore()
  const { data: directReports } = useCoachDirectReportsQuery()
  const { data: user } = useUserQuery()
  const { isAdmin } = useUserRole()

  const options = useMemo(() => {
    return [
      ...(isAdmin ? [{ label: "All coaches", value: null }] : []),
      ...(user ? [{ label: "Me", value: user.id }] : []),
      ...(directReports?.map((directReport) => ({
        label: directReport.coach_profile.user.name,
        value: directReport.coach_profile.user.id,
      })) ?? []),
    ]
  }, [directReports, user, isAdmin])

  const selectedCoach = useMemo(() => {
    return options.find((option) => option.value === selectedCoachUserId)
  }, [options, selectedCoachUserId])

  useEffect(() => {
    if (selectedCoachUserId || !user || isAdmin) return
    setSelectedCoachUserId(user.id)
  }, [user, selectedCoachUserId, setSelectedCoachUserId, isAdmin])

  return (
    <DropdownInput
      options={options}
      label={selectedCoach?.label ?? "Select Coach"}
      onSelect={(option) => setSelectedCoachUserId(option.value as number)}
      fullWidth
    />
  )
}

export default CoachDropdown
